import { Instance } from "mobx-state-tree";
import { Guest } from "../base/Guest";

export const CalendarGuest = Guest.named("CalendarGuest");

export type ICalendarGuest = Instance<typeof CalendarGuest>;
